module.exports = __webpack_public_path__ + "static/media/k8s_logo.ea9e4650.jpg";